"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleXAxisLegend = void 0;
var react_1 = __importDefault(require("react"));
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
function SingleXAxisLegend(_a) {
    var text = _a.text;
    if (!text)
        return null;
    return (react_1.default.createElement("ul", { className: "chart__composed__legend" },
        react_1.default.createElement("svg", { width: "24", height: "7", viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("rect", { width: "11.9015", height: "6.18164", rx: "3.09082", fill: Colors_1.ColorPalette.Purple }),
            react_1.default.createElement("path", { d: "M-24 3H24", stroke: "#726CF2", strokeLinecap: "round" })),
        react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, text)));
}
exports.SingleXAxisLegend = SingleXAxisLegend;
